export default "__VITE_ASSET__ZRG5iWbs__"